export default __webpack_public_path__ + "static/media/IMG4202.ab9261b2.jpg";